import Vue from 'vue';
import Router from 'vue-router';
import login from '@/views/login/index';
import shipment from '@/views/shipment/index';
import sale from '@/views/sale/index';
import monitor from '@/views/monitor/index';

Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: {name: 'login'}
    },
    {
      path: '/login',
      name: 'login',
      component: login
    },
    {
      path: '/shipment',
      name: 'shipment',
      component: shipment
    },
    {
      path: '/sale',
      name: 'sale',
      component: sale
    },
    {
      path: '/monitor',
      name: 'monitor',
      component: monitor
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js